/** basic.menuManage */
export default {
    menu_title: "Заголовок меню",
    menu_name: "Название меню",
    menu_path: "Путь меню",
    menu_grade: "Уровень меню",
    menu_deleteTips: "Удалить меню?",
    menu_details: "Детали",
    menu_addMenu: "Добавить меню",
    menu_menuDeatails: "Детали меню",
    menu_namePla: "Введите название меню",
    menu_pathPla: "Введите путь меню",
    menu_titlePla: "Введите заголовок меню",
    menu_icon: "Иконка меню",
    menu_iconPla: "Введите иконку меню",
    menu_type: "Тип меню",
    menu_typePla: "Введите тип меню",
    menu_module: "Компонент меню",
    menu_superiorsMenu: "Родительское меню",
    menu_ruleName: "Название меню не может быть пустым!",
    menu_rulePath: "Путь меню не может быть пустым!",
    menu_ruleLengthMax: "Длина от 1 до 50 символов!",
    menu_ruleTitle: "Заголовок меню не может быть пустым",
    menu_ruleIcon: "Иконка меню не может быть пустой!",
    menu_ruleType: "Тип меню не может быть пустым!",
    menu_ruleTypeLength: "Длина от 1 до 10 символов",
    menu_ruleGrade: "Уровень меню не может быть пустым",

    messge_deleteSucc: "Меню удалено!",
    messge_deleteLose: "Не удалось удалить меню!",
    messge_addMenuSucc: "Меню добавлено!",
    messge_addMenuLose: "Не удалось добавить меню!",
    messge_editSucc: "Меню изменено!",
    messge_editLose: "Не удалось изменить меню!",
}

